import Vue from 'vue'
import App from './App.vue'
import installVeTableRawTitlePatch from './utils/veTablePatch'
import router from './router'
import store from './store'
import VueCookies from 'vue-cookies'
import iView from 'iview';
import 'iview/dist/styles/iview.css';
import './assets/fonts/iconfont/iconfont.css'  //ICON 图标
import './assets/fonts/webfont/font.css'  // ICON FONT 字体
import './assets/css/global.scss'  // 全局样式

installVeTableRawTitlePatch(Vue)
 
import request from './utils/request' // 引入封装好的 axios
import splitPane from 'vue-splitpane'
Vue.component('split-pane', splitPane) //全局注册组件，在其它单页面vue实例 可以直接使用
import config from '@/config'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import * as echarts from 'echarts'
import './directive.js';
import 'babel-polyfill'
import global from '@/api/ws.js'
//组织架构图
import OrgTree from 'vue2-org-tree'
import 'vue2-org-tree/dist/style.css'
Vue.component('org-tree', OrgTree)
// 绘制各种复杂的Canvas图形
// import VueKonva from 'vue-konva'
// Vue.use(VueKonva)
import VxeUITable from 'vxe-table'
import 'vxe-table/es/style.css'
Vue.use(VxeUITable) 

import VxeUIAll from 'vxe-pc-ui'
import 'vxe-pc-ui/es/style.css'
Vue.use(VxeUIAll)

import VxeUIGantt from 'vxe-gantt'
import 'vxe-gantt/lib/style.css'
Vue.use(VxeUIGantt)

Vue.prototype.global = global
Vue.prototype.$echarts = echarts
Vue.use(ElementUI);
Vue.config.productionTip = false
import moment from 'moment'
Vue.prototype.$moment = moment

//使用
 
Vue.use(VueCookies);
 
Vue.use(iView)
/**
 * @description 全局注册应用配置,每一个vue组件都是vue的实例，所以组件内的this可以拿到 Vue.prototype上添加的属性和方法
 */
 Vue.prototype.$config = config
 Vue.prototype.$axios =request
 //request.defaults.headers.post['Content-type']='application/form-data;charset=UTF-8'
 
 
//vue 动态设置页面 title
import VueWechatTitle from 'vue-wechat-title'
Vue.use(VueWechatTitle)

//import video player
import VideoPlayer from 'vue-video-player'
require ('vue-video-player/src/custom-theme.css')
require('video.js/dist/video-js.css')
Vue.use(VideoPlayer)

import TreeTable from 'vue-table-with-tree-grid'
Vue.component('tree-table',TreeTable)

//配置   vue-easytable
import "vue-easytable/libs/theme-default/index.css"; // import style
import VueEasytable from "vue-easytable"; // import library
Vue.use(VueEasytable)
import { VeLocale } from "vue-easytable"
// 引入中文语言包
import zhCN from "vue-easytable/libs/locale/lang/zh-CN.js"

//多语言配置
import translate from '@/utils/translate'
const COMMON_LANG_LSTSEQ = '1'
const COMMON_LANG_IDSEQ = '471772'

function getLangDefault(cn, en, yn) {
  const lang = translate.normalizeLang(store.state.lang)
  if (lang === 'EN') return en
  if (lang === 'YN') return yn || cn
  return cn
}

function getCommonLang(key, def) {
  const lang = translate.normalizeLang(store.state.lang)
  const langPack = translate.getLoadedLangPack(COMMON_LANG_LSTSEQ, COMMON_LANG_IDSEQ)
  return translate.getLangText(langPack, lang, key, def)
}

function setVeEasytableLocale() {
  const pageText = getCommonLang('1660', getLangDefault('页', 'Page', 'trang'))
  VeLocale.use({
    ...zhCN,
    pagination: {
      ...zhCN.pagination,
      goto: getLangDefault('前往', 'Go to', 'Đến'),
      page: pageText,
      itemsPerPage: getLangDefault(' 条/页', ' / page', ' dòng/trang'),
      total: total => `${getLangDefault('共', 'Total', 'Tổng')} ${total} ${getLangDefault('条', 'items', 'dòng')}`.trim(),
      prev5: getLangDefault('向前 5 页', 'Previous 5 Pages', '5 trang trước'),
      next5: getLangDefault('向后 5 页', 'Next 5 Pages', '5 trang sau')
    }
  })
}

store.subscribe((mutation) => {
  if (mutation.type === 'setLocal') {
    setVeEasytableLocale()
  }
})

Vue.prototype.$translate = translate
// 公用语言包兼容入口；新代码统一通过 translate 底座取值。
Vue.prototype.$LANG = function (key, def = '') {
  return getCommonLang(key, def)
}
Vue.prototype.$routeTitle = function (route, fallback = '') {
  return this.$translate.getRouteTitle(
    route,
    this.$store.state.lang,
    fallback,
    this.$store.state.menuTitleMap
  )
}
/**配置cookies开始**/
//Vue.prototype.$cookies.config('6h','/') //默认保存6小时 根目录下
//ivew message 和 notcie 全局配置
Vue.prototype.$Message.config({
  top: 200,
  duration: 3
});
//全局设定
Vue.prototype.$Notice.config({
  top: 200,
  duration: 3
});
//使用v-loading
// import Directive from './directive'
// Vue.use(Directive)
//全局方法  限制input输入框只能输入纯数字 组件中调用如（<el-input v-enter-number v-model="number" ></el-input>）
Vue.directive('enterNumber', { 
  inserted: function(el) {
    el.addEventListener("keypress", function(e) {
      e = e || window.event;
      let charcode = typeof e.charCode === 'number' ? e.charCode : e.keyCode;
      let re = /\d/;
      if (!re.test(String.fromCharCode(charcode)) && charcode > 9 && !e.ctrlKey) {
        if (e.preventDefault) {
          e.preventDefault();
        } else {
          e.returnValue = false;
        }
      }
    });
  }
});
// 全局禁止输入双引号
window.addEventListener(
  "keydown",
  (e) => {
    if (e.key === '"') {
      e.preventDefault();
      return false;
    }
  },
  true
)
//挂载
translate.loadLangPack(COMMON_LANG_LSTSEQ, COMMON_LANG_IDSEQ)
  .catch((error) => {
    console.error('load common lang pack failed', error)
  })
  .finally(() => {
    setVeEasytableLocale()
    new Vue({
      router,
      store,

      render: h => h(App)
    }).$mount('#app')
  })
